import { IFilterList } from 'wisestep-base';

import ICVLibraryAdvanceSearch from '../types/ICVLibraryAdvanceSearch';

export const pushSearchFilters = (data: ICVLibraryAdvanceSearch) => {
  const filtersArray: IFilterList[] = [];
  if (data.stemPhrases)
    filtersArray.push({
      tag: `Stem Phrases: ${data.stemPhrases == '1' ? 'Yes' : 'No'}`,
      id: 'stemPhrases',
    });
  if (data.searchNameOnly)
    filtersArray.push({
      tag: `Search Name Only: ${data.searchNameOnly == '1' ? 'Yes' : 'No'}`,
      id: 'searchNameOnly',
    });
  if (data.relocation)
    filtersArray.push({
      tag: `Willing to Relocate: ${data.relocation == '1' ? 'Yes' : 'No'}`,
      id: 'relocation',
    });

  if (data.relocation)
    filtersArray.push({
      tag: `Willing to Relocate: ${data.relocation == '1' ? 'Yes' : 'No'}`,
      id: 'relocation',
    });

  if (data.salary)
    filtersArray.push({
      tag: `Search Salary: ${data.salary}`,
      id: 'salary',
    });

  if (data.industry)
    filtersArray.push({
      tag: `Industry: ${data.industry}`,
      id: 'industry',
    });

  if (data.minMatch)
    filtersArray.push({
      tag: `Minimum Matching: ${data.minMatch}`,
      id: 'minMatch',
    });

  return filtersArray;
};
